module.exports = __webpack_public_path__ + "static/media/image_2.ae620065.svg";